import { AppSyncToken } from 'common/models/token';
import React from 'react';
import { TokenUtils } from 'utils/tokenUtils';
import FormatFloat from '../FormatPercent/FormatFloat';
import { TokenIcon, TokenName } from '../TokenIcons/TokenIcon';

type Props = {
  ichi: AppSyncToken;
  xichi: AppSyncToken;
  icon: TokenName;
};

const XIchiRatioValueRow: React.FC<Props> = (props) => {
  return (
    <div className="flex flex-row justify-between py-2">
      <div className="flex flex-row items-center ichi-balance-header-text-color font-medium text-lg">
        <TokenIcon
          name={props.icon}
          height="34px"
          width="59px"
          marginRight="8px"
        />
        xICHI : ICHI
      </div>
      <div className="ichi-balance-header-text-color e2e-xichi-ichi font-medium text-lg">
        1 :
        <FormatFloat
          value={TokenUtils.getIchiStats(
            props.ichi,
            props.xichi
          ).ratio.toString()}
          displayDecimals={4}
          prefix=" "
        />
      </div>
    </div>
  );
};

export default XIchiRatioValueRow;
